import { gql } from "@apollo/client";

export const REQUEST_PAYMENT_FOR_INVOICES = gql`
  mutation requestPaymentForInvoices($invoiceIds: [String]) {
    requestPaymentForInvoices(invoiceIds: $invoiceIds) {
      success
      message
    }
  }
`;